import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Overlay, Wrapper, ModalContainer, Content, Header, Title, Body, BodyStyle, ButtonClose } from "./styles";
const Modal = /*#__PURE__*/React.memo(props => {
  const {
    isModalVisible,
    hide,
    options,
    children,
    rootNode
  } = props;

  function handleOverlayClicked({
    target
  }) {
    if (typeof target.className == "string" && target.className.indexOf("wrapper_modal") === -1) {
      return;
    }

    if (!options) {
      hide();
    } else {
      if (options.overlayClose !== false) {
        hide();
      }

      if (options.onOverlayClicked) {
        options.onOverlayClicked();
      }
    }
  }

  function renderBody() {
    if (children) {
      return children;
    }

    if (options && options.message) {
      return /*#__PURE__*/React.createElement(BodyStyle, null, options.message);
    }

    return false;
  }

  if (!isModalVisible) {
    return null;
  }
  /* { Fix over-scroll behavior  for modal content */


  const bodyElement = document.querySelector("body");

  const _refBody = React.useRef(bodyElement);

  const rootNodeElement = rootNode ? rootNode : bodyElement;
  React.useLayoutEffect(() => {
    if (isModalVisible && options !== null && options !== void 0 && options.overscrollBehaviorBlock) {
      bodyElement.style.overflow = "hidden";
    }

    return () => {
      const bodyElement = document.querySelector("body");

      if (bodyElement.style.overflow !== _refBody.current.style.overflow) {
        bodyElement.style.overflow = _refBody.current.style.overflow;
      }
    };
  }, [isModalVisible, options]);
  /* Fix over-scroll behavior  for modal content } */

  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement(Wrapper, {
    className: "wrapper_modal",
    isCentered: options && options.centered,
    isMobileViewportFit: options && options.isMobileViewportFit,
    "aria-modal": true,
    "aria-hidden": true,
    tabIndex: -1,
    role: "dialog",
    onClick: handleOverlayClicked
  }, /*#__PURE__*/React.createElement(ModalContainer, {
    isAnimated: options && options.animated
  }, /*#__PURE__*/React.createElement(Content, null, options !== undefined && options.closeButton === false ? null : /*#__PURE__*/React.createElement(Header, null, options !== undefined && options.title !== undefined && /*#__PURE__*/React.createElement(Title, null, options.title), /*#__PURE__*/React.createElement(ButtonClose, {
    onClick: hide
  })), /*#__PURE__*/React.createElement(Body, null, renderBody()))))), rootNodeElement);
});
export default Modal;
export const useModal = options => {
  const [hasToggledBefore, setHasToggledBefore] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const isModalVisibleRef = useRef(isModalVisible);
  isModalVisibleRef.current = isModalVisible;
  let timeoutHack;

  function toggle() {
    timeoutHack = setTimeout(() => {
      setIsModalVisible(!isModalVisibleRef.current);
      clearTimeout(timeoutHack);
    }, 10);
    setIsShown(!isShown);
    setHasToggledBefore(true);
  }

  function handleKeyDown(event) {
    if (event.keyCode !== 27 || options && options.keyboardClose === false) {
      return;
    }

    toggle();

    if (options && options.onEscapeKeyDown) {
      options.onEscapeKeyDown();
    }
  }

  useEffect(() => {
    if (isShown) {
      if (options && options.onShow) {
        options.onShow();
      }

      document.addEventListener("keydown", handleKeyDown);
      document.body.classList.add("modal-open");
    }

    if (!isShown && hasToggledBefore) {
      if (options && options.onHide) {
        options.onHide();
      }

      document.body.classList.remove("modal-open");
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isShown]);
  return [{
    isShown,
    isModalVisible,
    hide: toggle,
    options
  }, toggle];
};